import { useState, memo } from "react";
import { Icon } from "@/components/icons/Icon";
import { literals } from "@/constants/literals";
import { BASE_URL } from "@/constants/constants";
import SecondaryButton from "@/components/buttons/secondary-button/SecondaryButton";
import Modal from "@/components/modal/Modal";
import PrimaryButton from "@/components/buttons/primary-button/PrimaryButton";
import useGarageStore from "@/store/useGarbage.store";
import { useLocation, useNavigate } from "react-router-dom";

const HeaderDetail = ({ label, value }: { label: string; value: string }) => {
  return (
    <div className="px-6 md:pl-14 text-ib-pt-main">
      <label className="text-ib-pt-color-gray-1000">{label}</label>
      <p className="text-ib-pt-color-neutral-800 font-ib-bold">{value}</p>
    </div>
  );
};

const OrderHeader = () => {
  const { garageData, garageGroupData } = useGarageStore();
  const location = useLocation();
  const navigate = useNavigate();

  const [leaveModal, setLeaveModal] = useState<boolean>(false);

  const backToStandSelector = () => navigate(`${BASE_URL}/capture`);
  const switchLeaveModal = () =>
    setLeaveModal((previousState) => !previousState);

  const mustShowButton = () =>
    garageGroupData.length > 0 &&
    !(
      location.pathname.endsWith("/resume") ||
      location.pathname.endsWith("/resume/")
    );

  const goToOrderResume = () => navigate(`${BASE_URL}/capture/garage/resume`);

  return (
    <div className="w-screen">
      <div className="w-full h-[94px]  p-4 md:px-14 bg-ib-pt-color-neutral-100 border-b border-b-ib-pt-color-gray-100">
        <div className="h-8 mb-1 flex flex-row justify-between">
          <button
            type="button"
            onClick={switchLeaveModal}
            className="h-full text-ib-pt-color-red-500 flex flex-row items-center text-ib-pt-main"
          >
            <Icon name="backArrow" className="size-4 mr-4" />
            <span>{literals.leaveOrder}</span>
          </button>
          {mustShowButton() ? (
            <div>
              <SecondaryButton
                colour="red"
                size="small"
                icon="searchLens"
                label={literals.seeOrder}
                onClick={goToOrderResume}
              />
            </div>
          ) : null}
        </div>
        <h1 className="h-8 text-[24px] leading-[26px] font-ib-bold">
          {garageData?.orderNumber
            ? `${literals.order} ${garageData.orderNumber}`
            : literals.newOrder}
        </h1>
      </div>
      {garageData?.garage && garageData.step ? (
        <div className="grid grid-cols-2 md:flex md:flex-row md:justify-start py-4 bg-ib-pt-color-neutral-100 border-b border-b-ib-pt-color-gray-100">
          <HeaderDetail label={literals.garage} value={garageData.garage} />
          <HeaderDetail label={literals.step} value={garageData.step} />
        </div>
      ) : null}
      <Modal
        title={literals.leaveOrder}
        opened={leaveModal}
        onClose={switchLeaveModal}
      >
        <p className="mb-8 text-ib-pt-main text-ib-pt-color-gray-1000">
          {literals.leaveOrderQuestion}
        </p>
        <div className="mb-4">
          <PrimaryButton
            colour="red"
            label={literals.leave}
            onClick={backToStandSelector}
            size="medium"
            icon="exit"
          />
        </div>
        <div>
          <SecondaryButton
            colour="red"
            label={literals.cancel}
            onClick={switchLeaveModal}
            size="medium"
          />
        </div>
      </Modal>
    </div>
  );
};
export default memo(OrderHeader);
